import { render, staticRenderFns } from "./LunchEdit.vue?vue&type=template&id=137bb4d3&"
import script from "./LunchEdit.vue?vue&type=script&lang=js&"
export * from "./LunchEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports